<template>
  <ul>
    <li class="default-mb- palm-mb" v-for="(item, ix) in dataArr" :key="ix">
      <div class="layout layout--flush">
        <div class="layout__item u-12/24-default u-1/1-palm zeta">          
          {{item.Text}}
          <small class="u-text-color-grey">{{item.Limit}}</small>&nbsp;
        </div>
        <div class="layout__item u-4/24-default u-1/3-palm u-text-align--right u-text-color-grey">
          <small>{{item.Used}}</small>
        </div>
        <div class="layout__item u-4/24-default u-1/3-palm u-text-align--right u-text-color-grey">
          <small>{{item.Tariff}} {{item.TariffUnit}}</small>
        </div>
        <div
          class="layout__item u-4/24-default u-1/3-palm zeta u-text-align--right"
        >&nbsp; {{item.TotalUnit}} {{item.Total}}</div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
	props: ['data'],
	computed: {
		dataArr: function() {
			if (Array.isArray(this.data)) {
				return this.data;
			} else {
				return [this.data];
			}
		}
	}
};
</script>

<style>
</style>
